module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/fonts/glyphicons-halflings-regular.woff2
// module id = 129
// module chunks = 0